//Library Imports
import React from 'react'
import { Popover } from "antd";

//Style Imports
import styled from "styled-components";
import { IEventData } from "../interfaces";
import { EVENT_IDS } from '../constants';
import { ReactComponent as QuestionMark } from '../../../assets/img/questionMark.svg';

interface ITriggerItem {
  title: string;
  icon: object;
  info: string;
  eventData: IEventData;
  active: boolean;
}

const TriggerItem = (props: ITriggerItem) => {
  const { title, icon, info, active, eventData } = props;

  return (
    <Wrapper eventId={eventData.id} className={`${active ? "active" : ""}`}>
      <div className={`icon-wrapper justify-content-center d-flex`}>
        <Popover
          placement="bottomLeft"
          content={<b>{info}</b>}
          getPopupContainer={() => document.querySelectorAll(".list-of-triggers")[0] as HTMLElement}
          overlayClassName="trigger-popover"
        >
          <QuestionMark className="info-tab" />
        </Popover>
        <span className="align-self-center icon-cover">{icon}</span>
      </div>
      <div className="title-trigger">{title}</div>
    </Wrapper>
  );
};

export default TriggerItem;

const Wrapper = styled.div<{ eventId?: number }>`
  width: 160px;
  margin: 20px;
  cursor: pointer;
  @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
    width: 130px;
    margin: 12px;
  }
  &:hover,
  &.active {
    .icon-wrapper {
      background-color: #e6f5ea;
      border: 1px solid #1ec252;
      .info-tab {
        opacity: 1;
      }
      .icon-cover {
        svg {
          g,
          path {
            fill: #1ec252;
            stroke:${(props) => (props.eventId === EVENT_IDS.EMAIL_SEQUENCE ? "#1ec252;" : "")}
          }
        }
      }
    }
  }
  .icon-wrapper {
    height: 140px;
    border-radius: 8px;
    margin-bottom: 10px;
    border: 1px solid transparent;
    box-shadow: 0px 0px 17px -2px rgba(0, 0, 0, 0.08);
    position: relative;
    @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
      height: 120px;
    }
    .icon-cover {
      max-height: 47px;
      svg {
        g,
        path {
          fill: #000000;
        }
      }
    }
    .info-tab {
      position: absolute;
      top: 8px;
      right: 8px;
      color: #616161;
      font-size: 16px;
      line-height: 18px;
      width: 20px;
      height: 20px;
      text-align: center;
      opacity: 0;
      transition: 0.5s;
    }
  }
  .title-trigger {
    text-align: center;
    color: #424b50;
    font-size: 16px;
    font-weight: 500;
    line-height: 18px;
    font-family: "Roboto Slab", serif;
    padding: 0 25px;
    @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
      font-size: 12px;
      line-height: 16px;
    }
  }
`;
